import Reflux from 'reflux';

export default Reflux.createActions({
  cancel: {},
  confirm: { sync: true },
  prompt: {},
});
